export enum PlayerTag {
	PLAYER = "player_tag",
	BULLET = "bullet_tag",
}
